<template>
  <v-container
  v-if="person !== undefined"
  style="padding: 0px;">
    <v-app-bar light app color="white">

        <BackButton backTarget="/persons"/>
      <v-toolbar-title>{{person.name}}, {{person.type}}</v-toolbar-title>
    </v-app-bar>


    <v-row justify="center">
      <v-container
       style="margin: 0px; padding: 0px; width: 100%">
        <v-row justify="center">
          <v-col class="px-8">
            <v-btn
              color="primary"
              outlined
              rounded
              block
              v-if="userSignedIn && userOwnsPerson"
              :to="'/person/' + person.id + '/edit'"
            >Edit Websites</v-btn>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col class="px-8">
            <v-btn
              color="primary"
              rounded
              block
              v-if="userSignedIn"
              v-clipboard="currentUrl"
              @click="snackbar = true"
            >Share</v-btn>

          </v-col>
        </v-row>
        <SignUpTeaser v-if="!userSignedIn"/>

        <v-list>
          <template v-for="(item) in images">
            <v-list-item
              :key="item.url"
              style="padding: 0;"
              :to="'/person/' + person.id + '/image/' + item.id"
            >

            <ImagePreview
              :imageItem="item"
              :showFavIcon="userSignedIn"/>

            </v-list-item>
          </template>
        </v-list>

        <v-container v-if="isLoading" fill-height fluid>
          <v-row align="center">
              <v-col align="center">
                <v-progress-circular
                  indeterminate
                  color="blue"
                ></v-progress-circular>
              </v-col>
          </v-row>
        </v-container>

        <v-row v-else-if="images.length === 0"
            align="center"
            justify="center"
            class="px-8">
            Images from the websites of {{person.name}} will appear here. Click on "Edit Websites" to add a new website. Note that it might take a few minutes after you added a new website until the images appear here.
        </v-row>
      </v-container>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          OK
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import ImagePreview from '@/components/ImagePreview.vue';
import SignUpTeaser from '@/components/SignUpTeaser.vue';
import BackButton from '@/components/BackButton.vue';

let unsubImages;
let lastPersonFetch;
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Person',
  components: {
    SignUpTeaser,
    ImagePreview,
    BackButton,
  },
  data() {
    return {
      currentUrl: window.location,
      snackbar: false,
      snackbarText: 'Copied link to clipboard!',
      isLoading: true,
      isReloading: true,
      images: [],
      fetchedPerson: undefined,
      appState: this.$root.$data.appStore.state,
      appStore: this.$root.$data.appStore,
      analytics: this.$root.$data.analytics,
      imagesQuery: this.$root.$data.db.collection('image').where('personId', '==', this.$route.params.id).orderBy('priority', 'desc'),
      personQuery: this.$root.$data.db.collection('person').doc(this.$route.params.id),
    }
  },
  computed: {
    person: function () {
      let person = this.appState.persons.find((p) => p.id === this.$route.params.id);
      if(!person) {
        // If the person cannot be found in the store use the fetched person.
        // That might be undefined in this moment, but will be fetched!
        person = this.fetchedPerson;
      }
      return person;
    },
    userSignedIn: function () {
      return this.appState.user.uid !== undefined;
    },
    userOwnsPerson: function () {
      return this.appState.user.uid === this.person.owner;
    }
  },
  methods: {
    async fetchPersonIfMissing() {
      if (this.person) return;
      try {
        let personDoc = await this.personQuery.get();
        console.log(personDoc.data());
        this.fetchedPerson = {
          id: personDoc.id,
          name: personDoc.data().name,
          type: personDoc.data().type,
          owner: personDoc.data().owner,
        };
      } catch (error) {
        console.log(`Error fetching person data for id ${this.$route.params.id}: ${error}`)
        return;
      }
    },
    async fetchPersonImages () {
      let now = Date.now();
      if(lastPersonFetch) {
        const diffTime = Math.abs(now - lastPersonFetch);
        if(diffTime < 1000) {
          // Don't fetch images if the last fetch happened within a second ago.
          return;
        }
      }
      lastPersonFetch = now;

      this.isReloading = true;

      let images = [];
      let querySnapshot;
      try {
        querySnapshot = await this.imagesQuery.get();
      } catch (error) {
        console.log("Error getting documents: ", error);
        this.isReloading = false;
        this.isLoading = false;
        return;
      }
      querySnapshot.forEach((doc) => {
        images.push({
          id: doc.id,
          url: doc.data().url,
          websiteUrl: doc.data().websiteUrl,
          favouritedAt: doc.data().favouritedAt,
        });
        // console.log(doc.id, " => ", doc.data());
      });
      this.images = images;

      /*this.analytics.logEvent('content_loaded', {
        content_type: 'image',
        content_num: images.length,
        value: images.length,
      });*/
      this.isLoading = false;
      this.isReloading = false;
    },
  },
  mounted() {
    let fetchPersonImagesFunc = this.fetchPersonImages;
    unsubImages = !unsubImages && this.imagesQuery.onSnapshot(async function() {
      if (lastPersonFetch) {
        // Add a delay to avoid numerous queries when a new website with a lot
        // of pics is added if this is not the very first fetch.
        await new Promise(r => setTimeout(r, 750));
      }
     fetchPersonImagesFunc();
    });

    this.fetchPersonIfMissing();
  },
  beforeDestroy: function () {
    unsubImages && unsubImages();
    unsubImages = undefined;
  },
}
</script>
